function getPottedCalculationValues() {
  const potSize = document.getElementById('hedges-calculator__pot-size').value;
  const metres = document.getElementById('hedges-calculator__metres-potted').value;
  const rowType = document.getElementById('hedges-calculator__row-type').value;
  return { potSize, metres, rowType };
}

function getBareRootCalculationValues() {
  const size = document.getElementById('hedges-calculator__size').value;
  const metres = document.getElementById('hedges-calculator__metres-bare-root').value;
  return { size, metres };
}

function calculatePottedPlants({ potSize, metres, rowType }) {
  if (!metres || metres <= 0) return 0;

  let plantsPerMetre = 0;
  if (rowType === 'double') {
    plantsPerMetre = potSize === '9cm' ? 6 : 4;
  } else if (rowType === 'single') {
    plantsPerMetre = potSize === '9cm' ? 4 : 2;
  }

  return plantsPerMetre * metres;
}

function calculateBareRootPlants({ size, metres }) {
  if (!metres || metres <= 0) return 0;
  const plantsPerMetre = size === 'smaller' ? 7 : 5;
  return plantsPerMetre * metres;
}

function getPlantsLabel() {
  const form = document.getElementById('hedges-calculator');
  return form?.dataset.plantsLabel || 'plants.';
}

function updatePottedResult(plants) {
  const resultElement = document.getElementById('hedges-calculator__potted-result');
  const resultText = document.getElementById('hedges-calculator__potted-count');

  if (plants === 0) {
    resultElement.style.display = 'none';
    return;
  }

  resultText.innerText = `${plants} ${getPlantsLabel()}`;
  resultElement.style.display = 'block';
}

function updateBareRootResult(plants) {
  const resultElement = document.getElementById('hedges-calculator__bare-root-result');
  const resultText = document.getElementById('hedges-calculator__bare-root-count');

  if (plants === 0) {
    resultElement.style.display = 'none';
    return;
  }

  resultText.innerText = `${plants} ${getPlantsLabel()}`;
  resultElement.style.display = 'block';
}

function updateFormVisibility(productType) {
  if (productType === 'potted' || productType === 'bare-root') {
    document.getElementById('hedges-calculator__row-type').style.display = 'block';
    if (productType === 'potted') {
      document.getElementById('hedges-calculator__potted-form').style.display = 'block';
      document.getElementById('hedges-calculator__bare-root-form').style.display = 'none';
    }
    if (productType === 'bare-root') {
      document.getElementById('hedges-calculator__potted-form').style.display = 'none';
      document.getElementById('hedges-calculator__bare-root-form').style.display = 'block';
    }
  } else {
    document.getElementById('hedges-calculator__row-type').style.display = 'none';
    document.getElementById('hedges-calculator__potted-form').style.display = 'none';
    document.getElementById('hedges-calculator__bare-root-form').style.display = 'none';
  }
}

function updateRowTypeVisibility(productType) {
  const singleRow = document.getElementById('hedges-calculator__single-row');
  if (productType === 'bare-root') {
    updateRowTypeSelection('double');
    singleRow.style.display = 'none';
  } else {
    singleRow.style.display = 'inline-block';
  }
}

function updateRowTypeSelection(type) {
  document
    .getElementById('hedges-calculator__double-row')
    .classList.remove('hedges-calculator__row-type-button--selected');
  document
    .getElementById('hedges-calculator__single-row')
    .classList.remove('hedges-calculator__row-type-button--selected');
  document
    .getElementById(`hedges-calculator__${type}-row`)
    .classList.add('hedges-calculator__row-type-button--selected');
  document.getElementById('hedges-calculator__row-type').value = type;
}

function handleFormUpdate() {
  const productType = document.getElementById('hedges-calculator__product-type').value;
  updateFormVisibility(productType);
  updateRowTypeVisibility(productType);

  const pottedValues = getPottedCalculationValues();
  const pottedPlants = calculatePottedPlants(pottedValues);
  updatePottedResult(pottedPlants);

  const bareRootValues = getBareRootCalculationValues();
  const bareRootPlants = calculateBareRootPlants(bareRootValues);
  updateBareRootResult(bareRootPlants);
}

const calculator = document.getElementById('hedges-calculator');
if (calculator) {
  document.getElementById('hedges-calculator__product-type').addEventListener('change', handleFormUpdate);
  document.getElementById('hedges-calculator__double-row').addEventListener('click', () => {
    updateRowTypeSelection('double');
    handleFormUpdate();
  });
  document.getElementById('hedges-calculator__single-row').addEventListener('click', () => {
    updateRowTypeSelection('single');
    handleFormUpdate();
  });
  document.getElementById('hedges-calculator__pot-size').addEventListener('change', handleFormUpdate);
  document.getElementById('hedges-calculator__metres-potted').addEventListener('input', handleFormUpdate);
  document.getElementById('hedges-calculator__size').addEventListener('change', handleFormUpdate);
  document.getElementById('hedges-calculator__metres-bare-root').addEventListener('input', handleFormUpdate);
}
